





























import { Vue, Component, Prop } from "vue-property-decorator";
import OrganizationModel from "@/model/Organization";

@Component({})
export default class SummaryHcoList extends Vue {
  @Prop()
  readonly value!: OrganizationModel[];

  get organizationsFiltered() {
    return this.value.filter(
      (item: OrganizationModel) => item.hasOrganizationReportUrl
    );
  }
}
